import React from 'react';
import { InputText } from "primereact/inputtext";
import useFormError from '../../hooks/useFormError';
import '../css/Form.css'


const ProInputText = ({ id, labelText, value, rowCount = 1, style = { width: '100%' }, onChange, headerText, formik = {}, error, required, disabled = false  }) => {
  const getFormErrorMessage = useFormError(formik);
  const placeholderText = required?<label htmlFor="inputtext">{labelText}</label>: <label htmlFor="inputtext">{labelText}<span style={{fontSize:11}}>  (optional)</span></label>
  return (
    <div>
    <div className={"p-field " + (+rowCount === 2 ? "p-col-6" : "p-col-12")}  >
      {
        headerText &&
        <div className="p-d-flex p-jc-start">
          <h6 className="form-header">{headerText}</h6>
        </div>
      }
      <span className= {disabled?"p-float-label p-disabled": "p-float-label"}>
        <InputText id={id} style={{ ...style }} value={value || ""} onChange={onChange} />     
        {placeholderText}
      </span>     
    </div>
    <div>
      {error && getFormErrorMessage && getFormErrorMessage(error)}
      </div>
    </div>

  )
}

export default ProInputText;